














import Vue from "vue";

import IconLogin from "@joyz/app-core/assets/icons/lightblue/LogIn.svg";

import AuthCard from "@tt-app/components/user/auth/AuthCard.vue";
import AuthContainer from "@tt-app/components/user/auth/AuthContainer.vue";
import AuthError from "@tt-app/components/user/auth/AuthError.vue";
import {
  ROUTES,
  VUEX_USER_ACTION_NAMES,
  VUEX_USER_MUTATION_NAMES,
  VUEX_USER_NAMESPACE
} from "@tt-app/constants";

const TOKEN_KEY = "token";

interface Computed {
  hasLoginError: boolean;
  loginIcon: string;
  token: string | undefined;
}

export default Vue.extend<{}, {}, Computed, {}>({
  name: "Sso",
  components: { AuthCard, AuthContainer, AuthError },

  computed: {
    hasLoginError() {
      return !!this.$store.state.user.authentication.error;
    },
    loginIcon() {
      return IconLogin;
    },
    token() {
      // If there are multiple "token" query parameters (array paramters), there
      // will be an error
      const tokenCandidate = this.$route.query[TOKEN_KEY] as string | null;
      if (!tokenCandidate) {
        return undefined;
      }

      return tokenCandidate;
    }
  },

  async mounted() {
    const updateLoginFailure = `${VUEX_USER_NAMESPACE}/${VUEX_USER_MUTATION_NAMES.LOGIN_FAILURE}`;
    this.$store.commit(updateLoginFailure, undefined);

    if (this.token) {
      const action = `${VUEX_USER_NAMESPACE}/${VUEX_USER_ACTION_NAMES.LOGIN_SSO}`;
      await this.$store.dispatch(action, this.token);

      if (!this.$store.state.user.authentication.error) {
        const nextPath = (this.$route.query.nextPath as string) || ROUTES.HOME.PATH;
        this.$router.replace({ path: nextPath });
      }
    } else {
      this.$store.commit(updateLoginFailure, "Missing SSO token");
    }
  },

  methods: {}
});
